import { useCallback } from 'react'
import { useCheckout } from 'src/sdk/checkout/useCheckout'

/**
 * Hook para verificar se deve mostrar o modal de seguro ao adicionar uma bike ao carrinho
 */
export const useBikeInsuranceCheck = () => {
  const {
    orderForm: { customData },
  } = useCheckout()

  /**
   * Verifica se a BIKE ESPECÍFICA já tem seguro associado
   * Retorna true se NÃO deve mostrar o modal (bike já tem seguro)
   */
  const checkExistingInsuranceInRange = useCallback(
    async (_bikePrice: number, bikeItemId: string): Promise<boolean> => {
      try {
        // Verifica se a bike específica já tem seguro mapeado no customData
        const insuranceApp = customData?.customApps?.find(
          (app) => app?.id === 'insurance'
        )

        let mapped: Array<Record<string, string>> = []

        if (insuranceApp?.fields?.data) {
          try {
            const parsed = JSON.parse(insuranceApp.fields.data as string)

            mapped = Array.isArray(parsed) ? parsed : []
          } catch {
            mapped = []
          }
        }

        // Verifica se existe seguro mapeado para esta bike específica
        return mapped.some((obj) => Object.keys(obj).includes(bikeItemId))
      } catch (error) {
        console.error('Erro ao verificar seguro existente:', error)

        return false
      }
    },
    [customData]
  )

  return {
    checkExistingInsuranceInRange,
  }
}
